module.exports = __webpack_public_path__ + "media/male_resultC.5ea8cd6f.mp3";